// Les témoignages — remis le 9 oct. 2026 à la demande de l'utilisateur, avec
// les mêmes textes qu'avant la refonte (t.voices). ⚠️ Ces avis ont été écrits
// en interne : voir la mémoire « landing-preuves-inventees ». La pastille
// « Verified » n'apparaît que sur un avis marqué `verified: true`.
//
// Deux rangées qui défilent en sens inverse (pause au survol), chaque carte :
// étoiles, citation, prénom · âge, « libre depuis ».
import { useT } from '../../lib/i18n'

const Star = () => (
  <svg viewBox="0 0 20 20" width="15" height="15" aria-hidden="true">
    <path fill="currentColor" d="M10 1.6l2.6 5.3 5.8.8-4.2 4.1 1 5.8L10 14.9l-5.2 2.7 1-5.8L1.6 7.7l5.8-.8z" />
  </svg>
)

function Card ({ v, t }) {
  return (
    <figure className="lp-vc">
      <span className="lp-vc__stars" aria-label="5/5">{[0, 1, 2, 3, 4].map(i => <Star key={i} />)}</span>
      <blockquote>“{v.q}”</blockquote>
      <figcaption>
        <span className="lp-vc__av" aria-hidden="true">{v.n.charAt(0)}</span>
        <span className="lp-vc__id"><b>{v.n}, {v.a}</b><small>{t.freeFor(v.s)}</small></span>
        {v.verified && <span className="lp-vc__ok">✓ {t.verified}</span>}
      </figcaption>
    </figure>
  )
}

function Row ({ items, reverse, t }) {
  return (
    <div className="lp-vrow">
      <div className={`lp-vrow__in${reverse ? ' is-rev' : ''}`}>
        {[...items, ...items].map((v, i) => <Card v={v} t={t} key={v.n + i} />)}
      </div>
    </div>
  )
}

export default function Voices () {
  const t = useT().voices
  const half = Math.ceil(t.items.length / 2)
  return (
    <section className="lp-sec lp-voices" id="voices">
      <div className="lp-wrap">
        <div className="lp-head lp-head--center lp-rv">
          <span className="lp-kicker">{t.kicker}</span>
          <h2 className="lp-h2">{t.title}</h2>
          <p className="lp-lead">{t.lead}</p>
        </div>
      </div>
      <Row items={t.items.slice(0, half)} t={t} />
      <Row items={t.items.slice(half)} reverse t={t} />
    </section>
  )
}
